<template>
	<v-container grid-list-xs py-1 px-3 fluid h-100>
		<v-layout row wrap fill-height align-content-space-between py-0>
			<v-flex xs12 class="video-ai-panel__work-area pr-2">
				<v-textarea
					v-model="block.data.avatarPlainText"
					label="Write or paste your text"
					outlined
					rows="8"
					:counter="maxTextLength"
					:rules="[isTextValid]"
				/>

				<v-select
					v-if="!loadingVoices"
					v-model="block.data.avatarVoiceId"
					:items="voices"
					item-text="name"
					item-value="id"
					label="Select audio"
					outlined
					dense
				/>

				<v-layout row wrap v-if="!loadingAvatars">
					<v-flex xs6>
						<v-select
							v-model="block.data.avatarId"
							:items="avatars"
							item-text="name"
							item-value="name"
							label="Select avatar"
							outlined
							dense
						/>
					</v-flex>

					<v-flex xs6>
						<v-select
							v-if="block.data.avatarId"
							v-model="block.data.avatarStyle"
							:items="avatarStyles"
							label="Select avatar style"
							outlined
							dense
						/>
					</v-flex>
				</v-layout>

				<v-progress-circular v-if="loadingVoices || loadingAvatars" color="primary"></v-progress-circular>
			</v-flex>

			<v-flex xs12 class="text-xs-center video-ai-panel__footer">
				<v-btn color="primary" @click="handleGenerateAvatar" :disabled="!canGenerateAvatar">Generate</v-btn>

				<BerthaDisclaimer class="mt-2"></BerthaDisclaimer>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import BerthaDisclaimer from '../_components/placeholders/BerthaDisclaimer.vue';

export default {
	components: {
		BerthaDisclaimer
	},
	props: ['block', 'isAIWorking'],
	inject: ['aiService', 'lessonPlanController'],
	data() {
		return {
			voices: [],
			avatars: [],
			maxTextLength: 15000,
			loadingVoices: false,
			loadingAvatars: false
		};
	},
	async created() {
		await this.getVoices();
		await this.getAvatars();
	},
	computed: {
		canGenerateAvatar() {
			const isTextValid = this.isTextValid(this.block.data.avatarPlainText) === true;
			const hasAvatarId = Boolean(this.block.data.avatarId);
			const hasAvatarStyle = Boolean(this.block.data.avatarStyle);

			return isTextValid && hasAvatarId && hasAvatarStyle;
		},
		avatarStyles() {
			const avatar = this.avatars.find(avatar => avatar.name === this.block.data.avatarId);

			if (!avatar) return [];

			return avatar.styles;
		}
	},
	watch: {
		'block.data.avatarId': {
			handler() {
				this.block.data.avatarStyle = '';
			}
		}
	},
	methods: {
		isTextValid(text) {
			const isEmpty = text.trim() === '';
			if (isEmpty) return 'Text must not be empty';

			const isWithinRange = text.length < this.maxTextLength;
			if (!isWithinRange) return `Text exceeds ${this.maxTextLength} chars`;

			return true;
		},
		async getVoices() {
			try {
				this.loadingVoices = true;
				this.voices = await this.aiService.getAudioVoices();
			} catch (error) {
				this.lessonPlanController.showNotification(error);
			} finally {
				this.loadingVoices = false;
			}
		},
		async getAvatars() {
			try {
				this.loadingAvatars = true;
				this.avatars = await this.aiService.getVideoAvatars();
			} catch (error) {
				this.lessonPlanController.showNotification(error);
			} finally {
				this.loadingAvatars = false;
			}
		},
		async generateAvatar() {
			const result = await this.aiService.generateAvatarFrom(
				this.block.data.avatarPlainText,
				this.block.data.avatarVoiceId,
				this.block.data.avatarId,
				this.block.data.avatarStyle
			);

			return result;
		},
		async handleGenerateAvatar() {
			try {
				this.$emit('update:isAIWorking', true);

				this.block.data.avatarJobId = '';
				this.block.data.video = null;

				const jobId = await this.generateAvatar();
				this.block.data.avatarJobId = jobId;
			} catch (error) {
				this.lessonPlanController.showNotification(error);
			} finally {
				this.$emit('update:isAIWorking', false);
			}
		}
	}
};
</script>
<style scoped>
.video-ai-panel__work-area {
	max-height: 70%;
	overflow-y: scroll;
}
.video-ai-panel__footer {
	position: sticky;
	bottom: 0;
}
</style>